import API from "./api";

export const fetchLocations = () => API.get("/api/v1/company-location");

// ! Assets

// sign in a new user
export const signIn = (formData) => API.post("/api/v1/users/login", formData);
// the user already signed in to another app, if any (shared login cookie)
export const fetchSignedInUser = () => API.get("/api/v1/users/me");
// ends the shared login for every app in this browser
export const signOut = () => API.post("/api/v1/users/logout");

// Security
// forgot password
export const forgotPassword = (postData) =>
  API.post("/api/v1/users/forgotPassword", postData);

// reset password
export const resetPassword = (token, postData) =>
  API.patch(`/api/v1/users/resetPassword/${token}`, postData);

// reset password
export const changePassword = (postData) =>
  API.patch(`/api/v1/users/updateMypassword`, postData);

export const getUsers = () => API.get("/api/v1/users");

// ! Update users information and delete users
export const updateUser = (id, postData) =>
  API.patch(`/api/v1/users/update-user/info/${id}`, postData);
export const deleteUser = (id) =>
  API.delete(`/api/v1/users/delete-selected-user/info/${id}`);

// Authenticator-app sign-in: the code step after a correct password
export const twoFactorLoginVerify = (postData) =>
  API.post("/api/v1/users/two-factor/login/verify", postData);
export const twoFactorLoginSetup = (postData) =>
  API.post("/api/v1/users/two-factor/login/setup", postData);
export const twoFactorLoginSetupConfirm = (postData) =>
  API.post("/api/v1/users/two-factor/login/setup/confirm", postData);
// ...and the signed-in user's own authenticator app
export const getMyTwoFactor = () => API.get("/api/v1/users/two-factor/me");
export const startMyTwoFactorSetup = () =>
  API.post("/api/v1/users/two-factor/me/setup");
export const enableMyTwoFactor = (code) =>
  API.post("/api/v1/users/two-factor/me/enable", { code });
export const disableMyTwoFactor = (postData) =>
  API.post("/api/v1/users/two-factor/me/disable", postData);
export const newMyBackupCodes = (code) =>
  API.post("/api/v1/users/two-factor/me/backup-codes", { code });
